import * as angular from 'angular';
import FdxFileMapsConfirmNotificationEmailModalController from './fdx-file-maps-confirm-notification-email-modal.controller';
import { MODULE_NAME } from '../../../../config/constants';

import './fdx-file-maps-confirm-notification-email-modal.styles.scss';

export const componentName = 'fdxFileMapsConfirmNotificationEmailModal';

angular.module(MODULE_NAME).component(componentName, {
	template: require('./fdx-file-maps-confirm-notification-email-modal.template.html'),
	controller: FdxFileMapsConfirmNotificationEmailModalController,
	bindings: {
		// from uibmodal
		close: '&',
		dismiss: '&',
		resolve: '<?'
	}
});
